import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ManualTaxinvoicePageRoutingModule } from "./manual-taxinvoice-routing.module";

import { ManualTaxinvoicePage } from "./manual-taxinvoice.page";
import { MatTabsModule } from "@angular/material/tabs";
import { TaxInvoiceSelectComponent } from "../../tax-invoice/tax-invoice-select/tax-invoice-select.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualTaxinvoicePageRoutingModule,
    MatTabsModule,
  ],
  declarations: [
    ManualTaxinvoicePage,
    
  ],
  providers: [ManualTaxinvoicePage],
  exports: [
    ManualTaxinvoicePage,
  ],
})
export class ManualTaxinvoicePageModule {}
